/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {
  getExpenseList,
  getExpenseListForDealer
} from "@/api/Expense"

export default {
  addExpense({
    commit
  }, expense) {
    return new Promise((resolve, reject) => {
      commit('ADD_EXPENSE', expense)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchDataListItemsExpense({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      getExpenseList(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_EXPENSES', response.data);
            resolve(response);
          } else {
            reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {

          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  fetchDataListItemsExpenseForDealer({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      getExpenseListForDealer(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_EXPENSES', response.data);
            resolve(response);
          } else {
            reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {

          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  updateExpense({
    commit
  }, expense) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_EXPENSE', expense)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeExpense({
    commit
  }, expenseId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_EXPENSE', expenseId)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
};
